import React from 'react';
import "./RatingBox.css";
import { Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import DisplayRatingsOfSongBox from "./DisplayRatingsOfSongBox.js"

function RatingBox( {trackForBox, isExpanded, onToggle} ) {

const amountOfEntitledRatings = parseInt(trackForBox.entitledRatings, 10); //10=Dezimalsystem

  return (
    <Accordion
      expanded={isExpanded}
      onChange={onToggle}
      style={{
        marginBottom: '10px',
        boxShadow: 'none',
        borderRadius: '0',
        overflow: 'hidden',
        backgroundColor: '#000000',
        border: '1px solid #ff1493'
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon style={{ color: '#ff1493' }} />}
        style={{
          backgroundColor: '#000000',
          borderBottom: isExpanded ? '1px solid #ff1493' : 'none',
          minHeight: '64px',
          padding: '0 20px'
        }}
      >
        <div style={{ width: '100%' }}>
          <h3 style={{
            margin: '0',
            fontSize: '20px',
            fontWeight: 'bold',
            color: '#ffffff',
            letterSpacing: '-0.02em'
          }}>
            "{trackForBox.songName}" - Entitled for {amountOfEntitledRatings} Ratings
          </h3>
        </div>
      </AccordionSummary>

      <AccordionDetails style={{ padding: '20px', flexDirection: 'column', backgroundColor: '#000000' }}>
        <DisplayRatingsOfSongBox ratingInfo={trackForBox}/>
      </AccordionDetails>
    </Accordion>
  )
}
export default RatingBox;
